import { createSlice } from '@reduxjs/toolkit';
import { findDashboardOrder } from './api';
import { initialState } from './api/interface';

const dashboardOrderSlice = createSlice({
  name: 'dashboardOrder',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findDashboardOrder.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findDashboardOrder.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findDashboardOrder.rejected, (state, _) => {
      state.data = [];
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } = dashboardOrderSlice.actions;
export default dashboardOrderSlice.reducer;
